import { ajax } from "jquery";

$(function() {
  // let defaultSelect2Opts = {
  //   allowClear: true,
  //   placeholder: 'Pasirinkite',
  //   width: '100%'
  // };

  // $('.member-group-assignment').on('click', function(e) {
  //   let member_data = $($(this)[0]);
  //   $('#message_group_member_member_id').val(member_data.data('member-id'));
  //   $('#member_id').html(member_data.data('member-name'));
  // });

  let defaultSelect2Opts = {
    tags: false,
    allowClear: true,
    placeholder: 'Pasirinkite',
    width: '100%'
  };

  function initializeOwnershipMemberSelects(event, element){
    let ownership_member_options = $.extend(defaultSelect2Opts, {
      placeholder: "Įrašykite vardą, pavardę",
      minimumInputLength: 2,
      multiple: true,
      language: lt,
      tags: false,
      width: '80%',
      ajax: {
        quietMillis: 300,
        url: "/members/1/sandboxed_members.json",
        dataType: "json",
        data: function(term, page) {
          return {
            q: { name: term.term },
            page_limit: 100,
            page: page
          };
        },
        processResults: function(data) {
          return { results: data }
        }
      },
    });
    $(element).find("[rel='ownership_member_select']").each(function () {
      $(this).select2(ownership_member_options).on('select2:open', function (e) {
        var searchInput = $(this).data('select2').dropdown.$search || $(this).data('select2').selection.$search;
        searchInput[0].focus();
      });
    });
  }


  initializeOwnershipMemberSelects(null, $(document));


  function initializeMemberSelects(event, element){
    let member_options = $.extend(defaultSelect2Opts, {
      placeholder: "Įrašykite vardą, pavardę",
      minimumInputLength: 2,
      multiple: true,
      language: lt,
      tags: false,
      width: '100%',
      ajax: {
        quietMillis: 300,
        url: "/members.json",
        dataType: "json",
        data: function(term, page) {
          return {
            q: { name: term.term },
            page_limit: 100,
            page: page
          };
        },
        processResults: function(data) {
          return { results: data.members }
        }
      },
    });

    $(element).find("[rel='member_select']").each(function () {
      let url = $(this).data('url') || "/members.json";
      let field_options = $.extend({}, member_options, {
        ajax: $.extend({}, member_options.ajax, { url: url })
      });

      $(this).select2(field_options).on('select2:open', function (e) {
        let searchInput = $(this).data('select2').dropdown.$search || $(this).data('select2').selection.$search;
        searchInput[0].focus();
      });

      let member_ids = $(this).data('selected');
      if(member_ids){
        fetchMemberSelections($(this), url, member_ids);
      }
    }
    );
  }

  function fetchMemberSelections(field, url, params){
    if(params.length > 0){
      $.ajax({
        type: 'GET',
        url: url,
        data: {
          q: { members_id_in: params }
        }
      }).then(function (data) {
        data.members.map(function(el, index){
          if(isNaN(el.id)) return;           
          let option = new Option(el.text, el.id, true, true);
          $(field).append(option).trigger('change');
        });
      });
    }
  }

  initializeMemberSelects(null, $(document));

  function initializeMemberNameSelect(event, element){
    $(element).find("[rel='member_name_select']").each(function () {
      let field = $(this);
      let currentValue = field.data('value');
      
      let member_name_options = {
        placeholder: "Įrašykite pavadinimą",
        minimumInputLength: 2,
        tags: true,
        allowClear: true,
        language: lt,
        width: '100%',
        ajax: {
          quietMillis: 300,
          url: "/finance/members.json",
          dataType: "json",
          data: function(term, page) {
            return {
              q: { name: term.term },
              page_limit: 50,
              page: page
            };
          },
          processResults: function(data) {
            return { 
              results: data.members.map(function(member) {
                return {
                  id: member.text,
                  text: member.text
                };
              })
            }
          }
        },
      };

      field.select2(member_name_options);
      
      // Pre-populate current value for edit forms
      if(currentValue && currentValue.length > 0){
        let option = new Option(currentValue, currentValue, true, true);
        field.append(option).trigger('change');
      }
    });
  }

  initializeMemberNameSelect(null, $(document));

  function initializeMemberObjectNameSelect(event, element){
    $(element).find("[rel='member_object_name_select']").each(function () {
      let field = $(this);
      let currentValue = field.data('value');
      
      let member_object_name_options = {
        placeholder: "Įrašykite pavadinimą",
        minimumInputLength: 2,
        tags: true,
        allowClear: true,
        language: lt,
        width: '100%',
        ajax: {
          quietMillis: 300,
          url: "/finance/member_objects.json",
          dataType: "json",
          data: function(term, page) {
            return {
              q: { name: term.term },
              page_limit: 50,
              page: page
            };
          },
          processResults: function(data) {
            return { 
              results: data.member_objects.map(function(member_object) {
                return {
                  id: member_object.name,
                  text: member_object.name
                };
              })
            }
          }
        },
      };

      field.select2(member_object_name_options);
      
      // Pre-populate current value for edit forms
      if(currentValue && currentValue.length > 0){
        let option = new Option(currentValue, currentValue, true, true);
        field.append(option).trigger('change');
      }
    });
  }

  initializeMemberObjectNameSelect(null, $(document));

  $('thead .member-checkbox').on('click', function(e) {
    if($(this).prop('checked')) {
      $('tbody .member-checkbox').prop('checked', true);
      $('#message-group-modal').modal('show');
      $('#new_q').find('.form-control').each(function() {
        let input = $(this);
        let name = input.attr('name');
        if(name === 'utf8' || name === 'authenticity_token' || name ==='commit') return;
        if($('#message-group-modal form').find(`input[name="${name}"]`).length > 0) return;
        let value = input.val();
        $('#message-group-modal form').append(`<input type="hidden" name="${name}" value="${value}">`);
      });
    }
  });

  $('#message-group-modal').on('hidden.bs.modal', function(e) {
    $('thead .member-checkbox').prop('checked', false);
    $('tbody .member-checkbox').prop('checked', false);
  });


  $('.member-group-assignment').on('click', function(e) {
    let message_group_data = $($(this)[0]);
    let newOption = new Option(message_group_data.data('member-name'), message_group_data.data('member-id'), true, true);
    $('#message-group-member-modal #message_group_member_member_id').append(newOption).trigger('change');
  });

  function resizeEmailFrame(iframe) {
    try {
      let doc = iframe.contentWindow && iframe.contentWindow.document;
      if (!doc) return;
      let height = Math.max(
        doc.documentElement ? doc.documentElement.scrollHeight : 0,
        doc.body ? doc.body.scrollHeight : 0
      );
      if (height) iframe.style.height = (height + 16) + 'px';
    } catch (e) {
    }
  }

  document.addEventListener('load', function(event) {
    if (event.target && event.target.classList && event.target.classList.contains('email-body-frame')) {
      resizeEmailFrame(event.target);
    }
  }, true);

  $(document).on('shown.bs.modal', '.modal', function() {
    $(this).find('.email-body-frame').each(function() {
      resizeEmailFrame(this);
    });
  });
});
